const initializedMessages = new WeakSet();

export function initializeSignInMessage(root = document) {
  if (!root.body?.classList.contains('mhecomm-he-pdp-page')) return;
  const message = root.querySelector('.hePdpSignMessage');
  if (!message || initializedMessages.has(message)) {
    return;
  }

  initializedMessages.add(message);
  const update = (view) => message.classList.toggle('d-none', view === 'student');
  const activeToggle = root.querySelector('.studentInstructorToggleGroup .nav-link.active');
  update(
    activeToggle?.dataset.layerPdpViewType || new URLSearchParams(window.location.search).get('viewOption') || 'student'
  );
  document.addEventListener('studentInstructorToggleGroupChange', (event) => update(event.detail?.value));
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initializeSignInMessage(), { once: true });
} else {
  initializeSignInMessage();
}
